'use client'

import { useEffect, useRef, useState } from 'react'
import styles from './ua.module.scss'
import ApiUtils from '@/utils/ApiUtils';
import { emitEvent } from '@/components/plugins/EventListener';

const highlightDisplayOrders = [
  'Great for Family',
  'Great For Work',
  'Under 20K',
  'Low Miles',
  'New',
  'Great Deal',
  'Popular',
  'Hot',
]

const specsDisplayOrders = [
  'Exterior Color',
  'Interior Color',
  'Engine',
  'Transmission',
  'Drivetrain',
  'Fuel Type',
  'Fuel Efficiency',
  'Seats',
  'Doors',
]

export default function VehicleFeaturesProvider(props) {
  
  const vehicle = props.vehicle


  const buildInfo = (items, large) => {
    return <div className={ styles.specs }>
      { items.map((item, index) => (
      <div key={index}>
        {/* <div>&middot;</div> */}
        { Array.isArray(item) && (item[0] + "").toLowerCase() != (item[4] + "").toLowerCase() ?
        <div>
          <div className='flex-column'>
            <div className='text-xs text-primary'>{ item[0] }</div>
            <div className={'' + (large ? ' text-md text-bold' : '')}>{ item[1] }</div>
          </div>
        </div>
        :
        <div className={'text-sm' + (large ? ' text-md text-bold' : '')}>{ item[0] }</div>
        }
      </div>
      ))}
    </div>
  }

  useEffect(() => {
    loadSpecs()
  }, [])

  const loadSpecs = () => {

    let highlightValues = []
    let specsList = []
    let basicData = {}
    let info = { 
      packages: { title: "Packages", items: [] },
      exterior: { title: "Exterior Features & Specs", items: [] },
      interior: { title: "Interior Features & Specs", items: [] },
      power: { title: "Power & Mechanical", items: [] },
      convenience: { title: "Convenience", items: [] },
      technology: { title: "Technology", items: [] },
      entertainment: { title: "Entertainment", items: [] },
      comfort: { title: "Comfort", items: [] },
      safety: { title: "Safety", items: [] },
      warranty: { title: "Standard Warranty", items: [] },
    }
    specsList.push({ items: ['Exterior Color', vehicle.exterior_color], displayOrder: specsDisplayOrders.indexOf('Exterior Color') })
    specsList.push({ items: [ 'Interior Color', vehicle.interior_color], displayOrder: specsDisplayOrders.indexOf('Interior Color') })
    if (vehicle.specs?.fuel_type) {
      specsList.push({ items: ['Fuel Type', vehicle.specs?.fuel_type], displayOrder: specsDisplayOrders.indexOf('Fuel Type') })
    }
    if (vehicle.specs?.drive_train) {
      specsList.push({ items: ['Drivetrain', vehicle.specs?.drive_train], displayOrder: specsDisplayOrders.indexOf('Drivetrain') })
    }
    if (vehicle.prices.price < 20000 || vehicle.prices.msrp < 20000) {
      highlightValues.push({ icon: 'dollar', label: 'Under 20K', displayOrder: highlightDisplayOrders.indexOf('Under 20K') })
    }
    if (vehicle.condition != 1 && vehicle.mileage < 30000) {
      highlightValues.push({ icon: 'speedometer', label: 'Low Miles', displayOrder: highlightDisplayOrders.indexOf('Low Miles') })
    }
    highlightValues.push({ icon: 'viewed', label: 'Popular', displayOrder: highlightDisplayOrders.indexOf('Popular') })
    highlightValues.push({ icon: 'thumbs-up', label: 'Hot', displayOrder: highlightDisplayOrders.indexOf('Hot') })
    highlightValues.push({ icon: 'new', label: 'New', displayOrder: highlightDisplayOrders.indexOf('New') })
    ApiUtils.getRequest("/specs/api/ymmt/cars/" + vehicle.id + "/details").then(data => {
      data.options?.filter(e => e.isStandard).map(item => {
        if (item.group == 'Engine') {
          specsList.push({ items: ['Engine', item.optionDescription], displayOrder: specsDisplayOrders.indexOf('Engine') })
        }
        if (item.group == 'Transmission') {
          if (basicData.transmission) {
            basicData.transmission[1] += ", " + item.optionDescription
          } else {
            basicData.transmission = ['Transmission', item.optionDescription ]
          }
        }
        if (item.group == 'Suspension') {
          if (basicData.suspension) {
            basicData.suspension[1] += ", " + item.optionDescription
          } else {
            basicData.suspension = ['Suspension', item.optionDescription ]
          }
        }
        if (item.group == 'Tire & Wheels') {
          if (basicData.tire_wheels) {
            basicData.tire_wheels[1] += ", " + item.optionDescription
          } else {
            basicData.tire_wheels = ['Tire & Wheels', item.optionDescription ]
          }
        }
        if (item.group == 'Seating') {
          if (basicData.seats) {
            basicData.seats[1] += ", " + item.optionDescription
          } else {
            basicData.seats = ['Seating', item.optionDescription ]
          }
        }
        if (item.group == 'Entertainment') {
          if (basicData.entertainment) {
            basicData.entertainment[1] += ", " + item.optionDescription
          } else {
            basicData.entertainment = ['Entertainment', item.optionDescription ]
          }
        }
      })
      data.technical_specs?.powertrain_and_mechanical?.filter(e => e.is_standard).map(item => {
        if (item.description == 'Drive type') {
          if (basicData.drivetrain) {
            basicData.drivetrain[1] += ", " + item.name
          } else {
            basicData.drivetrain = ['Drivetrain', item.name ]
          }
        }
        if (item.description == 'Horsepower') {
          if (basicData.horsepower) {
            basicData.horsepower[1] += ", " + item.name
          } else {
            basicData.horsepower = ['Horsepower', item.name ]
          }
        }
        if (item.description == 'Torque') {
          if (basicData.torque) {
            basicData.torque[1] += ", " + item.name
          } else {
            basicData.torque = ['Torque', item.name ]
          }
        }
        if (item.description == 'Displacement') {
          if (basicData.displacement) {
            basicData.displacement[1] += ", " + item.name
          } else {
            basicData.displacement = ['Displacement', item.name ]
          }
        }
        if (item.description == 'Fuel Type') {
          if (basicData.fuel_type) {
            basicData.fuel_type[1] += ", " + item.name
          } else {
            basicData.fuel_type = ['Fuel Type', item.name ]
          }
        }
      })
      data.technical_specs?.fuel_economy_and_emissions?.filter(e => e.is_standard).map(item => {
        if (item.description == 'Fuel economy city') {
          if (basicData.fuel_eco_city) {
            basicData.fuel_eco[1] += ", " + item.name + " City"
          } else {
            basicData.fuel_eco = ['Fuel Economy', item.name + " City" ]
          }
        }
        if (item.description == 'Fuel economy highway') {
          if (basicData.fuel_eco) {
            basicData.fuel_eco[1] += " / " + item.name + " Hwy"
          } else {
            basicData.fuel_eco = ['Horsepower', item.name + " Hwy" ]
          }
        }
      })
      let basicInfo = []
      if (basicData.engine) basicInfo.push(basicData.engine)
      if (basicData.transmission) basicInfo.push(basicData.transmission)
      if (basicData.suspension) basicInfo.push(basicData.suspension)
      if (basicData.drivetrain) basicInfo.push(basicData.drivetrain)
      if (basicData.horsepower) basicInfo.push(basicData.horsepower)
      if (basicData.torque) basicInfo.push(basicData.torque)
      if (basicData.displacement) basicInfo.push(basicData.displacement)
      if (basicData.fuel_type) basicInfo.push(basicData.fuel_type)
      if (basicData.fuel_eco) basicInfo.push(basicData.fuel_eco)
      if (basicData.tire_wheels) basicInfo.push(basicData.tire_wheels)
      if (basicData.seats) basicInfo.push(basicData.seats)
      if (basicData.entertainment) basicInfo.push(basicData.entertainment)
      if (data['sytle_data']['curbWeight']) basicInfo.push(['Curb Weight', data['sytle_data']['curbWeight'] ])
      basicInfo.push(['VIN', vehicle.vin])
      basicInfo.push(['Stock #', vehicle.stock_number])
      // data.packages?.packages?.map(item => {
      //   info.packages.items.push(item.name)
      // })
      data.technical_specs?.interior_specs?.map(item => {
        if (item.is_standard) info.interior.items.push([item.description, item.name])
      })
      data.features?.exterior_and_appearance?.map(item => {
        if (item.is_standard) info.exterior.items.push([item.description, item.name])
      })
      data.technical_specs?.exterior_specs?.map(item => {
        if (item.is_standard) info.exterior.items.push([item.description, item.name])
      })
      data.technical_specs?.powertrain_and_mechanical?.map(item => {
        if (item.is_standard) info.power.items.push([item.description, item.name])
      })
      data.features?.comfort?.filter(e => e.is_standard).map(item => {
        info.comfort.items.push([item.description,item.name])
        if (item.description == 'Seating capacity') {
          if (parseInt(item.name) > 5) {
            highlightValues.push({ icon: 'family-friendly', label: 'Great for Family', displayOrder: highlightDisplayOrders.indexOf('Great for Family') })
          }
          specsList.push({ items: ['Seats', item.name], displayOrder: specsDisplayOrders.indexOf('Seats') })
        }
      })
      data.features?.safety_and_security?.map(item => {
        if (item.is_standard) info.safety.items.push([item.description,item.name])
      })
      data.features['in-car_entertainment'].map(item => {
        if (item.is_standard) info.entertainment.items.push([item.description,item.name])
      })
      data.features['technology_and_telematics'].map(item => {
        if (item.is_standard) info.technology.items.push([item.description,item.name])
      })
      data.features['convenience'].map(item => {
        if (item.is_standard) info.convenience.items.push([item.description,item.name])
      })
      data.features['original_warranty'].map(item => {
        if (item.is_standard) info.warranty.items.push([item.description,item.name])
      })
      let list = []
      if (info.packages.items.length > 0) {
        list.push({ title: info.packages.title, partial: buildInfo(info.packages.items) })
      }
      if (info.exterior.items.length > 0) {
        list.push({ title: info.exterior.title, partial: buildInfo(info.exterior.items) })
      }
      if (info.interior.items.length > 0) {
        list.push({ title: info.interior.title, partial: buildInfo(info.interior.items) })
      }
      if (info.power.items.length > 0) {
        list.push({ title: info.power.title, partial: buildInfo(info.power.items) })
      }
      if (info.convenience.items.length > 0) {
        list.push({ title: info.convenience.title, partial: buildInfo(info.convenience.items) })
      }
      if (info.entertainment.items.length > 0) {
        list.push({ title: info.entertainment.title, partial: buildInfo(info.entertainment.items) })
      }
      if (info.technology.items.length > 0) {
        list.push({ title: info.technology.title, partial: buildInfo(info.technology.items) })
      }
      if (info.comfort.items.length > 0) {
        list.push({ title: info.comfort.title, partial: buildInfo(info.comfort.items) })
      }
      if (info.safety.items.length > 0) {
        list.push({ title: info.safety.title, partial: buildInfo(info.safety.items) })
      }
      if (vehicle.condition == 1 && info.warranty.items.length > 0) {
        list.push({ title: info.warranty.title, partial: buildInfo(info.warranty.items) })
      }
      if (data.sytle_data.standardPayload && data.sytle_data.standardPayload > 1000) {
        highlightValues.push({ icon: 'great-for-work', label: 'Great For Work', displayOrder: highlightDisplayOrders.indexOf('Great For Work') })
      }
      const featureData = {
        details: list,
        basic: basicInfo,
        highlights: highlightValues.sort((a,b) => { return (a - b > 0 ? -1 : 1) } ),
        specs: specsList.sort((a,b) => { return (a.displayOrder - b.displayOrder > 0 ? 1 : -1) } ).map(e => e.items)
      }
      emitEvent("vehicle_features_loaded", featureData)
    }).catch(err => {
      if (vehicle.specs?.doors) {
        specsList.push({ items: ['Doors', vehicle.specs?.doors], displayOrder: specsDisplayOrders.indexOf('Doors') })
      }
      if (vehicle.specs?.transmission) {
        specsList.push({ items: ['Transmission', vehicle.specs?.transmission], displayOrder: specsDisplayOrders.indexOf('Transmission') })
      }
      const featureData = {
        showFeedDetails: true,
        highlights: highlightValues.sort((a,b) => { return (a - b > 0 ? -1 : 1) } ),
        specs: specsList.sort((a,b) => { return (a.displayOrder - b.displayOrder > 0 ? 1 : -1) } ).map(e => e.items)
      }
      emitEvent("vehicle_features_loaded", featureData)
    })
  }

  return <></>

}
